/* eslint-disable jsx-a11y/anchor-is-valid */
import React from "react";
import { useTranslation } from "react-i18next";
import ok from "../../assets/images/svg/ok.svg";
import aboutTwo from "../../assets/images/all-img/sp-section-img.webp";

const Platform = () => {
  const { t } = useTranslation(); // Initialize translation

  return (
    <div className="bg-[url('../images/all-img/section-bg-16.png')] bg-cover bg-no-repeat bg-center section-padding">
      <div className="container">
        <div className="lg:grid grid-cols-12 gap-[30px]">
          {/* Left Side - Text Content */}
          <div className="xl:col-span-5 lg:col-span-6 col-span-12">
            <div className="mini-title">{t("platform.mini_title")}</div>
            <h4 className="column-title">
              {t("platform.title").split(" ")[0]}{" "}
              <span className="shape-bg">
                {t("platform.title").split(" ")[1]}
              </span>{" "}
              {t("platform.title").split(" ").slice(2).join(" ")}
            </h4>

            {/* Features List */}
            <ul className="space-y-2 pt-8">
              {["feature1", "feature2", "feature3", "feature4", "feature5"].map(
                (feature, index) => (
                  <li className="flex flex-wrap" key={index}>
                    <div className="flex-none mr-3">
                      <div>
                        <img src={ok} alt="Check Icon" />
                      </div>
                    </div>
                    <div className="flex-1">
                      <h4 className="text-lg mb-1 font-semibold">
                        {t(`platform.${feature}`)}
                      </h4>
                    </div>
                  </li>
                )
              )}
            </ul>
          </div>

          {/* Right Side - Image */}
          <div className="xl:col-span-7 lg:col-span-6 col-span-12 lg:pt-0 md:pt-10 pt-6">
            <img
              src={aboutTwo}
              alt="About Platform"
              className="mx-auto block w-full"
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Platform;
